export default __webpack_public_path__ + "static/6909-0940e428d2e9f6e15e5924b3d7f6a0b8.jpg";